import { render, staticRenderFns } from "./DisclaimerPage.vue?vue&type=template&id=086dd6e8&"
import script from "./DisclaimerPage.vue?vue&type=script&lang=js&"
export * from "./DisclaimerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports